export default "__VITE_ASSET__fcce5216__"